import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "roomTableTr" }
const _hoisted_3 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`roomTableTd centered fw600 fs16`)
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`roomTableTd centered fw600 fs20 lskyblueBg`)
}
const _hoisted_7 = {
  class: "fl centered",
  style: {"width":"110px"}
}
const _hoisted_8 = { class: "fw600 arial fs24" }
const _hoisted_9 = {
  key: 0,
  style: {"width":"70px","margin-top":"5px"},
  class: "fl centered"
}
const _hoisted_10 = {
  key: 1,
  style: {"width":"70px","margin-top":"5px"},
  class: "fl centered"
}
const _hoisted_11 = {
  class: "fl centered",
  style: {"width":"130px"}
}
const _hoisted_12 = { class: "fw600 arial fs24" }
const _hoisted_13 = {
  key: 2,
  class: "fl",
  style: {"width":"70px","margin-top":"5px"}
}
const _hoisted_14 = {
  key: 3,
  class: "fl",
  style: {"width":"70px","margin-top":"5px"}
}
const _hoisted_15 = {
  key: 4,
  class: "fl centered",
  style: {"width":"90px"}
}
const _hoisted_16 = { class: "fw600 arial fs24" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fs11" }, "%", -1)
const _hoisted_18 = {
  key: 5,
  class: "fl centered",
  style: {"width":"70px","margin-top":"5px"}
}
const _hoisted_19 = {
  key: 6,
  class: "fl",
  style: {"width":"70px","margin-top":"5px"}
}
const _hoisted_20 = {
  key: 7,
  class: "fl centered",
  style: {"width":"120px"}
}
const _hoisted_21 = { class: "fw600 arial fs24" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "fs11" }, "日", -1)
const _hoisted_23 = {
  key: 8,
  class: "fl",
  style: {"width":"120px"}
}
const _hoisted_24 = {
  key: 9,
  class: "fl centered",
  style: {"width":"70px","margin-top":"5px"}
}
const _hoisted_25 = {
  key: 10,
  class: "fl",
  style: {"width":"70px","margin-top":"5px"}
}
const _hoisted_26 = {
  key: 11,
  class: "fl centered",
  style: {"width":"130px"}
}
const _hoisted_27 = { class: "fw600 arial fs24" }
const _hoisted_28 = {
  key: 12,
  class: "fl centered",
  style: {"width":"70px","margin-top":"5px"}
}
const _hoisted_29 = {
  key: 13,
  class: "fl",
  style: {"width":"60px","margin-top":"5px"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_31 = { colspan: "3" }
const _hoisted_32 = { class: "w100" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  colspan: "3",
  class: "pad15"
}
const _hoisted_35 = { class: "fl w20 fs14 fw600 ml20" }
const _hoisted_36 = { class: "fl mt10 fs14" }
const _hoisted_37 = { class: "fl w70 mt5" }
const _hoisted_38 = {
  key: 0,
  class: ""
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30" }, " ", -1)
const _hoisted_40 = { class: "fl w50" }
const _hoisted_41 = { class: "fs24 fw600 fl arial" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt8" }, "件", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "fl w30" }
const _hoisted_46 = { class: "circleBlueButton selected fl fs17 pad5 mr20" }
const _hoisted_47 = { class: "fs13 fw600 fl mt7" }
const _hoisted_48 = { class: "fl w50 mt2" }
const _hoisted_49 = { class: "fs24 fw600 fl arial" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt8" }, "件", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!

  return (_ctx.stat)
    ? (_openBlock(), _createElementBlock("tbody", _hoisted_1, [
        _createElementVNode("tr", _hoisted_2, [
          (_ctx.type == `user`)
            ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
                (_ctx.user)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.user.name), 1))
                  : _createCommentVNode("", true),
                _hoisted_5,
                _createElementVNode("p", {
                  class: "fs11 skyblue mt6 pointer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openFixedPerAstag && _ctx.openFixedPerAstag(...args)))
                }, "▼ 調整カレンダーごとの内訳")
              ]))
            : (_openBlock(), _createElementBlock("td", _hoisted_6, "全体")),
          _createElementVNode("td", {
            class: _normalizeClass(`posRe ${_ctx.type == `all` ? `lskyblueBg` : ``}`)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(`fl fw400 pointer`),
              style: _normalizeStyle({
                    marginTop: _ctx.isSP ? `0px` : ``,
                })
            }, [
              _createElementVNode("ul", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.startNum), 1),
                  _createTextVNode(" (" + _toDisplayString(_ctx.stat.parents_last.length) + ") ", 1)
                ]),
                (_ctx.parentsMom)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.parentsMom > 0 ? `△` : `▼`) + " " + _toDisplayString(Math.abs(Math.round(_ctx.parentsMom))) + "% ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, " ")),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.stat.time_spans.length), 1),
                  _createTextVNode(" (" + _toDisplayString(_ctx.stat.time_spans_last.length) + ") ", 1)
                ]),
                (_ctx.timeSpansMom)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.timeSpansMom > 0 ? `△` : `▼`) + " " + _toDisplayString(Math.abs(Math.round(_ctx.timeSpansMom))) + "% ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, " ")),
                (_ctx.fixRatio)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(Math.abs(Math.round(_ctx.fixRatio))), 1),
                      _hoisted_17,
                      _createTextVNode(" (" + _toDisplayString(Math.abs(Math.round(_ctx.fixRatioLast)) || "-") + ") ", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.fixRatioMom)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.fixRatioMom > 0 ? `△` : `▼`) + " " + _toDisplayString(Math.abs(Math.round(_ctx.fixRatioMom))) + "% ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, " ")),
                (_ctx.aveTimeSpan)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.aveTimeSpan), 1),
                      _hoisted_22,
                      _createTextVNode(" (" + _toDisplayString(Math.abs(_ctx.aveTimeSpanLast || 0)) + ") ", 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, " ")),
                (_ctx.aveTimeSpanMom)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.aveTimeSpanMom > 0 ? `△` : `▼`) + " " + _toDisplayString(Math.abs(Math.round(_ctx.aveTimeSpanMom))) + "% ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, " ")),
                (_ctx.stat.messages)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.stat.messages.length), 1),
                      _createTextVNode(" (" + _toDisplayString(Math.abs(Math.round(_ctx.stat.messages_last.length))) + ") ", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.messagesMom)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.messagesMom > 0 ? `△` : `▼`) + " " + _toDisplayString(Math.abs(Math.round(_ctx.messagesMom))) + "% ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, " "))
              ])
            ], 4)
          ], 2),
          _hoisted_30
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_31, [
            _createElementVNode("table", _hoisted_32, [
              (_ctx.isOpenDetail)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stat.fixed_appo_per_astag, (mag_arr, astag_id) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        height: "70",
                        key: `${astag_id}${_ctx.openReportUserIds}`
                      }, [
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_CalendarIcon, {
                              astag: _ctx.stat.astags_dic[astag_id],
                              width: 40,
                              iconWidth: 40,
                              totalHeight: 40,
                              canDelete: false,
                              hideName: true,
                              hideBorder: true,
                              class: "fl noBorder mr10"
                            }, null, 8, ["astag"]),
                            _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.stat.astags_dic[astag_id].name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mag_arr, (assigned_mag_info, magindex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "pad10 hoverLgreyBg rad10",
                                key: magindex
                              }, [
                                (assigned_mag_info.name == `no_mag`)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      _hoisted_39,
                                      _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("p", _hoisted_41, _toDisplayString(assigned_mag_info.fixed_appo_num), 1),
                                        _hoisted_42
                                      ]),
                                      _hoisted_43
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("div", _hoisted_46, _toDisplayString(assigned_mag_info.mag_info.name), 1),
                                        _createElementVNode("div", _hoisted_47, _toDisplayString(assigned_mag_info.mag_info.team_name), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("p", _hoisted_49, _toDisplayString(assigned_mag_info.fixed_appo_num), 1),
                                        _hoisted_50,
                                        _hoisted_51
                                      ]),
                                      _hoisted_52
                                    ]))
                              ]))
                            }), 128)),
                            _hoisted_53
                          ]),
                          _hoisted_54
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}